import { Injectable, inject } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { UserPreferences } from '../models/preferences.model';
import { GenericApiService } from './generic-api.service';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {
  private api = inject(GenericApiService);

  getPreferences(): Observable<UserPreferences> {
    return this.api.query<UserPreferences>('GET_PREFERENCES').pipe(
      catchError(err => {
        console.error('Error in PreferencesService.getPreferences', err);
        throw err;
      })
    );
  }

  updatePreferences(preferences: UserPreferences): Observable<any> {
    return this.api.query<any>('UPDATE_PREFERENCES', preferences).pipe(
      catchError(err => {
        console.error('Error in PreferencesService.updatePreferences', err);
        throw err;
      })
    );
  }
}
